const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/coil-binding-machines`,
    saveSpeedTable: `${API_URL}/coil-binding-machine/save-speed-table`
};

export default apiUrls;
